var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievemy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.945 42.4296L55.9319 70.4943C55.9878 70.8248 55.9414 71.1645 55.799 71.4679C55.6566 71.7713 55.425 72.024 55.1351 72.1922C54.8452 72.3604 54.5109 72.4361 54.1768 72.4091C53.8427 72.3822 53.5249 72.2539 53.2657 72.0414L41.4815 63.1967C40.9126 62.7717 40.2215 62.5421 39.5114 62.5421C38.8013 62.5421 38.1103 62.7717 37.5414 63.1967L25.7375 72.0381C25.4785 72.2502 25.161 72.3783 24.8273 72.4053C24.4936 72.4323 24.1597 72.3569 23.87 72.1891C23.5803 72.0214 23.3486 71.7693 23.2059 71.4665C23.0632 71.1637 23.0162 70.8246 23.0712 70.4943L28.0548 42.4296",
    stroke: "#111111",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 46.0833C50.4076 46.0833 59.25 37.241 59.25 26.3333C59.25 15.4257 50.4076 6.58334 39.5 6.58334C28.5924 6.58334 19.75 15.4257 19.75 26.3333C19.75 37.241 28.5924 46.0833 39.5 46.0833Z",
    stroke: "#111111",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievemy);
export default __webpack_public_path__ + "static/media/achievemy.c529ba80d4360267ada8f470cc027431.svg";
export { ForwardRef as ReactComponent };